/**
 * Customer portal product catalogue (buy journey entry points).
 */
import { isCustomerPaEnabled } from '@/utils/paChannel';
import { isCustomerTravelEnabled } from '@/utils/travelChannel';
import { isCustomerMotorV2Enabled } from '@/utils/motorChannel';

const customerPaLive = isCustomerPaEnabled();
const customerTravelLive = isCustomerTravelEnabled();
const customerMotorV2 = isCustomerMotorV2Enabled();
const COMING_SOON_NOTE = 'Coming soon';
export const CUSTOMER_PRODUCT_CATEGORIES = [
  { id: 'all', label: 'All products' },
  { id: 'general', label: 'General insurance' },
  { id: 'health', label: 'Health' },
];

export const CUSTOMER_PRODUCTS = [
  {
    id: 'motor',
    category: 'general',
    name: 'Motor Insurance',
    description: 'Private vehicles. Comprehensive and third-party cover.',
    icon: 'ph-car',
    mdiIcon: 'mdi-car-outline',
    accent: '#184679',
    live: true,
    soon: false,
    tags: ['Comprehensive', 'Third Party'],
    route: customerMotorV2
      ? { name: 'CustomerMotorStart' }
      : { name: 'Request', query: { product: 'motor' } },
    cardClass: '',
  },
  {
    id: 'pa',
    category: 'general',
    name: 'Personal Accident',
    description: 'Students PA — accidental death, disability and medical benefits.',
    icon: 'ph-first-aid',
    mdiIcon: 'mdi-hospital-box-outline',
    accent: '#7c3aed',
    live: customerPaLive,
    soon: !customerPaLive,
    soonNote: customerPaLive ? null : 'Direct purchase launching soon',
    tags: ['Students', 'Option 1–3'],
    route: customerPaLive ? { name: 'CustomerPaPlanSelect' } : null,
    cardClass: '',
  },
  {
    id: 'travel',
    category: 'general',
    name: 'Travel Insurance',
    description: 'Pacis Travel Protect for local and international trips.',
    icon: 'ph-airplane-tilt',
    mdiIcon: 'mdi-airplane',
    accent: '#0284c7',
    live: customerTravelLive,
    soon: !customerTravelLive,
    hero: true,
    soonNote: customerTravelLive ? null : COMING_SOON_NOTE,
    tags: ['Single trip', 'Multi-trip'],
    route: customerTravelLive ? { name: 'CustomerTravelPlanSelect' } : null,
    cardClass: 'ps-card--travel',
  },
  {
    id: 'amani',
    category: 'health',
    name: 'Pacis Amani',
    description: 'Medical cover for you and your family.',
    icon: 'ph-heartbeat',
    mdiIcon: 'mdi-heart-pulse',
    accent: '#0d9488',
    live: false,
    soon: true,
    soonNote: COMING_SOON_NOTE,
    tags: ['Inpatient', 'Outpatient'],
    route: null,
    cardClass: 'ps-card--amani',
  },
  {
    id: 'domestic',
    category: 'general',
    name: 'Domestic Package',
    description: 'Home buildings, contents and domestic workers.',
    icon: 'ph-house',
    mdiIcon: 'mdi-home-outline',
    accent: '#ea580c',
    live: false,
    soon: true,
    soonNote: COMING_SOON_NOTE,
    tags: ['Buildings', 'Contents'],
    route: null,
    cardClass: 'ps-card--domestic',
  },
  {
    id: 'sme',
    category: 'general',
    name: 'SME Package',
    description: 'Business protection for small and medium enterprises.',
    icon: 'ph-briefcase',
    mdiIcon: 'mdi-briefcase-outline',
    accent: '#16a34a',
    live: false,
    soon: true,
    tags: ['Fire', 'Liability'],
    route: null,
    cardClass: 'ps-card--sme',
  },
];

export const CUSTOMER_LIVE_PRODUCTS = CUSTOMER_PRODUCTS.filter((p) => p.live);
export const CUSTOMER_DASHBOARD_PRODUCTS = CUSTOMER_PRODUCTS.filter((p) => p.id !== 'sme');
